const TERM_LABELS: Record<string, string> = {
  monthly: 'month',
  quarterly: 'quarter',
  annual: 'year',
};

export function formatSeatPrice(
  pricePerSeat: number,
  billingTerm: string,
  currency: string = 'usd'
): string {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(pricePerSeat);
  const termLabel = TERM_LABELS[billingTerm] || billingTerm;
  return `${formatted}/seat/${termLabel}`;
}

export function formatMonthlyEquivalent(
  pricePerSeat: number,
  billingTerm: string,
  currency: string = 'usd'
): string | null {
  let monthlyPrice: number;
  if (billingTerm === 'quarterly') monthlyPrice = pricePerSeat / 3;
  else if (billingTerm === 'annual') monthlyPrice = pricePerSeat / 12;
  else return null; // Already monthly
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(monthlyPrice);
  return `${formatted}/seat/month`;
}

export function formatProration(
  amount: number,
  currency: string = 'usd'
): string {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount / 100);
  return `${formatted} (prorated)`;
}
